import { usePBaseStore } from '@/store';

export function configGlobalProperties() {
  const baseStore = usePBaseStore();
  // 全局管理
  // TODO: 去掉any报错
  window.__VAST2T_LOWCODE__ = {
    /** 应用名称 */
    appName: baseStore.appName,
    /** 主题 */
    theme: 'white',
    // /** 调试 */
    // process: process.env,
    // /** wps SDK对象 */
    // WpsSDK,
    /** 插件信息 */
    pluginInfo: {},
  } as any;
}
